import {Divider} from '@mantine/core';
import {BasicButton, WhiteBgButton} from '@packages/ui';
import Image from 'next/image';
import {useRouter} from 'next/router';
import {IoMdPersonAdd} from 'react-icons/io';
import {
  MdEmail,
  MdExitToApp,
  MdForum,
  MdInsertDriveFile,
  MdOutlineDomain,
} from 'react-icons/md';
import {LOGIN, PROFILE_AC_EMAIL} from '../../../../config/constants/routes';
import {isReleasedRedesignTop} from '../../../../config/unReleasePage';
import {QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE} from '../../../../core/entities/login/constants';
import {CommonLink} from '../../../../shared/components/CommonLink';
import {useIsAppWebView} from '../../../../shared/hooks/useIsAppWebView';
import {getMailAuthLinkWithParamsHooks} from '../../../../shared/services/getMailAuthLinkWithParamsHooks';

type Props = {
  isStudentVerificationRequired?: boolean;
};

export const LogInGuideHeaderForSp: React.FC<Props> = ({
  isStudentVerificationRequired,
}) => {
  const isWebView = useIsAppWebView();
  const SP_TOP_HEADER_LOGO =
    '/next-image/common/logo/sp-top-header-background.png';
  const SP_TOP_HEADER_DESC_LOGO =
    '/next-image/common/logo/sp-top-header-description.png';
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});
  const router = useRouter();

  const promotionList: Array<{
    title: string;
    icon: React.ReactNode;
  }> = [
    {
      title: '厳選企業の新卒採用情報',
      icon: <MdOutlineDomain size={24} />,
    },
    {
      title: '先輩就活生の体験記',
      icon: <MdInsertDriveFile size={24} />,
    },
    {
      title: 'Premiumスカウト',
      icon: <MdEmail size={24} />,
    },
    {
      title: '選考対策コラム',
      icon: <MdForum size={24} />,
    },
  ];

  if (isReleasedRedesignTop()) {
    return (
      <div className="pc:hidden flex flex-col bg-white rounded-16 gap-16 p-16">
        <div className="text-sm text-black-1">
          外資就活ドットコムは、プロフェッショナルを目指す学生のための就職活動支援メディアです。
          {isStudentVerificationRequired &&
            '会員限定サービスのご利用には大学認証の完了が必要です。'}
        </div>
        <div className="w-full">
          <Divider
            size={2}
            label={
              <div className="text-sm border-[1px] p-8 px-16 border-black-1 text-black-1 rounded-full">
                会員限定サービス
              </div>
            }
            labelPosition="center"
          />
        </div>
        <div className="flex flex-col gap-16 px-16 text-base">
          <div className="flex flex-col gap-16">
            {promotionList.map((promotion) => (
              <div key={promotion.title} className="flex gap-4 items-center">
                <div>{promotion.icon}</div>
                <div className="font-bold">{promotion.title}</div>
              </div>
            ))}
          </div>
          <div className="w-full flex gap-16 items-center justify-center mx-auto">
            {isStudentVerificationRequired ? (
              <CommonLink
                href={PROFILE_AC_EMAIL}
                className="w-full bg-primary-1 text-white font-bold border-2 border-primary-1 py-8 rounded-full items-center justify-center"
              >
                <div className="flex justify-center items-center gap-4">
                  大学認証を完了する
                </div>
              </CommonLink>
            ) : (
              <>
                <CommonLink
                  href={mailAuthLink}
                  className="w-full bg-accent-1 text-white font-bold border-2 border-accent-1 py-8 rounded-full items-center justify-center"
                >
                  <div className="flex justify-center items-center gap-4">
                    <IoMdPersonAdd />
                    新規会員登録
                  </div>
                </CommonLink>
                <CommonLink
                  href={'/login'}
                  className="w-full flex text-primary font-bold border-2 border-primary py-8 rounded-full items-center justify-center"
                >
                  <div className="flex justify-center items-center gap-4">
                    <MdExitToApp />
                    ログイン
                  </div>
                </CommonLink>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="block w-full pc:hidden">
      <div
        id="sp-top-header"
        style={{backgroundImage: `url(${SP_TOP_HEADER_LOGO})`}}
        className="h-[350px]"
      >
        <div className="max-w-[328px] mx-auto">
          <Image
            src={SP_TOP_HEADER_DESC_LOGO}
            className="text-center mx-auto"
            width={328}
            height={152}
            alt="header description"
          />
          <div>
            <BasicButton
              isPrimary={true}
              className="my-32"
              onClick={() => {
                location.href = isStudentVerificationRequired
                  ? PROFILE_AC_EMAIL
                  : mailAuthLink;
              }}
            >
              {isStudentVerificationRequired
                ? '大学認証を完了する'
                : '無料会員登録'}
            </BasicButton>
          </div>
          {!isStudentVerificationRequired && (
            <WhiteBgButton
              label="ログイン"
              isPrimary={false}
              isLarge={false}
              className="w-full my-32"
              onClick={async () => {
                const path = `${LOGIN}?${QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE}=${router.asPath}`;
                if (isWebView) {
                  location.href = path;
                } else {
                  await router.push(path);
                }
              }}
            />
          )}
        </div>
      </div>
      <div className="text-sm p-4 text-left">
        <span className="mx-16 text-black-2">企業研究を読む</span>
        <CommonLink href="/company/1" className="mr-16 text-link">
          マッキンゼー
        </CommonLink>
        <CommonLink href="/company/21" className="mr-16 text-link">
          ゴールドマン
        </CommonLink>
        <CommonLink href="/company/37" className="text-link">
          三菱商事
        </CommonLink>
      </div>
    </div>
  );
};
